var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",staticClass:"historico-modal-full",attrs:{"buttons":['cancel'],"title":`Paciente: ${_vm.paciente.nome}`,"extraLarge":""}},[_c('div',{staticClass:"historico-wrapper"},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"no-footer-sorting":"","sort-by":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }